export enum EnrollmentTreeTabSelectViewTypes {
    TREE = 'tree',
    TABLE = 'table'
}
